import { Typography, Paper, Divider } from '@mui/material'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import './checks.scss'
import { useTranslation } from 'react-i18next'
import { formatRegistrationDate } from '../../../../../components/common/time/timeHelper'

const CheckSocialAssistance = ({ socialAssistanceCheck }) => {
  const { t } = useTranslation(['common', 'messages'])
  const details = socialAssistanceCheck?.checkDetails
  const found = socialAssistanceCheck?.found

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:socialAssistance')}</Typography>
      </Paper>

      <CheckDetailTitle
        email={socialAssistanceCheck?.email}
        status={socialAssistanceCheck?.status}
        createdAt={socialAssistanceCheck?.createdAt}
        updatedAt={socialAssistanceCheck?.updatedAt}
      />

      {found ? (
        <TimelineDotLine>
          <Paper elevation={0} variant="rootOutlined" sx={{ flex: 1 }}>
            <Typography variant="subtitle2" sx={{ mb: 2 }}>
              {t('common:summary')}
            </Typography>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalAssistances')}</Typography>
                <Typography variant="subtitle3">{details?.TotalAssistances ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalActiveAssistances')}</Typography>
                <Typography variant="subtitle3">{details?.TotalActiveAssistances ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalIncome')}</Typography>
                <Typography variant="subtitle3">{details?.TotalIncome ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalAmountReceived')}</Typography>
                <Typography variant="subtitle3">{details?.TotalAmountReceived ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:totalInstallmentsReceived')}</Typography>
                <Typography variant="subtitle3">{details?.TotalInstallmentsReceived ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">{t('common:isReceivingAssistance')}</Typography>
                <Typography variant="subtitle3">{details?.IsReceivingAssistance ? t('common:yes') : t('common:no')}</Typography>
              </div>
            </div>
            <Divider sx={{ my: 2 }} />
            <Typography variant="subtitle2" sx={{ mb: 2 }}>
              {t('common:assistancesList')}
            </Typography>
            {details?.SocialAssistances?.length > 0 ? (
              details.SocialAssistances.map((item, idx) => (
                <Paper key={idx} elevation={0} variant="rootOutlined" sx={{ mb: 2, p: 1 }}>
                  <Typography variant="subtitle3" sx={{ mb: 1 }}>{item.ProgramName}</Typography>
                  <div className="c-detail-grid">
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:programCountry')}</Typography>
                      <Typography variant="subtitle3">{item.ProgramCountry ?? '---'}</Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:programState')}</Typography>
                      <Typography variant="subtitle3">{item.ProgramState ?? '---'}</Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:assistanceStartDate')}</Typography>
                      <Typography variant="subtitle3">{formatRegistrationDate(item.AssistanceStartDate)}</Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:assistanceEndDate')}</Typography>
                      <Typography variant="subtitle3">{formatRegistrationDate(item.AssistanceEndDate)}</Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:assistanceAmount')}</Typography>
                      <Typography variant="subtitle3">{item.AssistanceAmount ?? '---'}</Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:assistanceTotalAmount')}</Typography>
                      <Typography variant="subtitle3">{item.AssistanceTotalAmount ?? '---'}</Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:totalInstallments')}</Typography>
                      <Typography variant="subtitle3">{item.TotalInstallments ?? '---'}</Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:county')}</Typography>
                      <Typography variant="subtitle3">{item.AssistanceDetails?.County ?? '---'}</Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:creationDate')}</Typography>
                      <Typography variant="subtitle3">{formatRegistrationDate(item.CreationDate)}</Typography>
                    </div>
                    <div className="c-detail-row">
                      <Typography variant="subtitle1">{t('common:lastUpdateDate')}</Typography>
                      <Typography variant="subtitle3">{formatRegistrationDate(item.LastUpdateDate)}</Typography>
                    </div>
                  </div>
                </Paper>
              ))
            ) : (
              <Typography variant="body2">{t('common:noAssistancesFound')}</Typography>
            )}
          </Paper>
        </TimelineDotLine>
      ) : (
        <Paper variant="rootOutlined" elevation={0}>
          <Typography variant="subtitle3">{t('common:noDataFound')}</Typography>
        </Paper>
      )}
    </>
  )
}

export default CheckSocialAssistance
